import { createAPIModule } from '@/api/utils';

export default createAPIModule({
  endpoint: 'tipoestadoinmuebles',
  getAllParams: ({ page, perPage, search }) => ({
    'filter[nombre]': search,
    page,
    per_page: perPage,
  }),
});
